<template>
  <div class="leadlist-step-3">
    <snow-select
      id="event"
      label="Quando o seguinte evento acontecer"
      :options="typeEvents"
      v-model="form.event"
    />
    <snow-select
      id="commands"
      label="O comando a seguir será executado no provedor"
      :options="typeCommands.filter(t => t.name === 'Adicionar tag ao contato')"
      v-model="form.command"
    />
    <snow-select
      v-if="provider && provider.name === 'leadlovers'"
      v-model="form.tag"
      id="tags"
      label="Selecione uma tag"
      :errors="errors.tag"
      :options="[...tags]"
    />
    <tag-input
      v-if="provider && provider.name === 'rdstation'"
      v-model="form.tags"
      placeholder="Separe as tags com vírgulas"
      class="m-0"
    />
  </div>
</template>

<script>
import { clearObject } from "@/functions/helpers";
import { mapState } from "vuex";

export default {
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    errors: {
      type: Object,
      default: () => {}
    },
    provider: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState("integration", ["typeEvents", "typeCommands", "tags"])
  },
  data: () => ({ tag_options: [], loadingTags: false }),
  mounted() {
    this.fetchTags();
    this.dispatchTypeEvents();
    this.dispatchTypeCommands();
  },
  methods: {
    fetchTags() {
      if (!this.provider) return;

      this.loadingTags = true;

      this.$store
        .dispatch(
          "integration/getLeadLoversTags",
          clearObject({
            provider_id: this.provider.id
          })
        )
        .then()
        .finally(() => {
          this.loadingTags = false;
        });
    },
    dispatchTypeEvents() {
      this.loading = true;
      this.$store
        .dispatch("integration/getTypeEvents")
        .then()
        .catch(error => {
          if (error.response && error.response.data.detail) {
            this.$message.error(error.response.data.detail);
          } else {
            this.$message.error("Não foi possível carregar os provedores");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    dispatchTypeCommands() {
      this.loading = true;
      this.$store
        .dispatch("integration/getTypeCommands")
        .then()
        .catch(error => {
          if (error.response && error.response.data.detail) {
            this.$message.error(error.response.data.detail);
          } else {
            this.$message.error("Não foi possível carregar os provedores");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style scoped lang="scss">
.leadlist-step-3 {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
